/**
 * This component handle the router configuration for the safety screens.
 */
import React from 'react';
import { Route } from 'react-router-dom';
import loadableModule from 'spark-views/main/loadableModule';
import { paths } from './notificationRoutes';

const SafetyNotifications = loadableModule(() =>
    import(/* webpackChunkName: "safetyNotifications" */ './index')
);

const SafetyLetterRecipientsRoute = () => (
    <Route path={paths.root} component={SafetyNotifications} />
);

export default SafetyLetterRecipientsRoute;
